export const contact = {
  phone: "01059599903",
  phoneLabel: "010-5959-9903",
  kakao: "https://open.kakao.com/me/Bobins",
  instagram:
    "https://www.instagram.com/mov2un?igsi=MWJrdXNlMmh3aTJvOQ%3D%3D&utm_source=qr",
};

export const strengths = [
  {
    title: "설계사가 바뀌지 않습니다",
    body: "담당자가 자주 바뀌어 “내 보험을 아무도 모르는” 상황, 겪어보셨죠. 이동은은 떠나지 않고 처음부터 끝까지 당신의 보험을 책임집니다.",
  },
  {
    title: "팔지 않고, 먼저 진단합니다",
    body: "지금 가입한 보험부터 꼼꼼히 분석합니다. 필요 없는 건 정리하고, 부족한 보장만 채웁니다. 무리한 권유는 하지 않습니다.",
  },
  {
    title: "필요할 때 바로 연결됩니다",
    body: "아플 때, 사고 났을 때, 가장 막막한 순간에 전화 한 통이면 됩니다. 청구 서류부터 절차까지 옆에서 챙겨드립니다.",
  },
];

export const promises = [
  [
    "평생 1:1 전담 관리",
    "가입 후가 진짜 시작입니다. 매년 보장 점검과 변화 안내를 직접 챙깁니다.",
  ],
  [
    "보험금 청구 끝까지 동행",
    "복잡한 서류와 절차, 받으셔야 할 보험금까지 함께 챙깁니다.",
  ],
  ["정직한 보장 분석", "중복·과잉은 줄이고 꼭 필요한 보장에 집중합니다."],
  [
    "내게 꼭 맞는 맞춤 설계",
    "지금 상황과 목표에 맞춰 꼭 필요한 보장만 담아 설계합니다.",
  ],
  [
    "가족 전체를 함께",
    "나 한 명이 아니라 가족 모두의 보장을 한눈에 관리합니다.",
  ],
  [
    "부담 없는 상담",
    "가입을 강요하지 않습니다. 궁금증을 푸는 것부터 시작합니다.",
  ],
];

export const services = [
  [
    "무료 보장 분석",
    "현재 가입한 모든 보험을 한 장으로 정리해 드립니다. 어디가 부족하고 어디가 겹치는지 명확하게 보여드려요.",
  ],
  [
    "보험 리모델링",
    "오래된 보험, 부담되는 보험료를 진단해 꼭 필요한 보장만 남기고 합리적으로 재설계합니다.",
  ],
  [
    "맞춤 신규 설계",
    "나이·직업·가족 상황에 맞춰 꼭 필요한 보장을 우선순위대로 제안합니다.",
  ],
  [
    "보험금 청구 지원",
    "진단·수술·사고 시 받으셔야 할 보험금을 빠짐없이, 서류 준비부터 끝까지 함께합니다.",
  ],
  [
    "가족 통합 관리",
    "부모님·배우자·자녀까지 가족 전체의 보장을 한 사람이 통합 관리해 드립니다.",
  ],
  [
    "은퇴·노후 준비",
    "연금·저축성 상품으로 막연한 노후 걱정을 구체적인 계획으로 바꿔 드립니다.",
  ],
];

export const steps = [
  ["편하게 연락", "전화·카톡·인스타 어디로든 편한 채널로 연락 주세요."],
  ["현황 듣기", "지금 상황과 고민을 충분히 듣습니다. 정답은 사람마다 달라요."],
  ["분석·제안", "객관적으로 분석하고, 필요한 것만 솔직하게 제안드립니다."],
  ["평생 관리", "결정하셨다면, 그때부터 평생 곁에서 관리해 드립니다."],
];

export const reviews = [
  {
    initial: "김",
    name: "김OO 고객님",
    detail: "30대 · 직장인",
    body: "전에는 담당자가 계속 바뀌어서 내 보험을 아무도 몰랐어요. 동은 님은 제 상황을 다 기억하고 챙겨주셔서 정말 든든합니다.",
  },
  {
    initial: "이",
    name: "이OO 고객님",
    detail: "40대 · 자영업",
    body: "보험금 청구할 때 뭘 어떻게 해야 할지 막막했는데, 서류부터 절차까지 차근차근 챙겨주셔서 큰 도움이 됐어요. 강요 없이 솔직해서 더 신뢰가 갑니다.",
  },
  {
    initial: "박",
    name: "박OO 고객님",
    detail: "50대 · 주부",
    body: "중복된 보장을 정리해 불필요한 부분을 덜 수 있었어요. 무조건 들라고 안 하시고 제 입장에서 봐주셔서 가족 보험도 다 맡겼습니다.",
  },
];

export const faqs = [
  [
    "상담하면 꼭 가입해야 하나요?",
    "아니요. 가입은 전혀 의무가 아닙니다. 지금 보험이 잘 되어 있다면 “잘 되어 있다”고 솔직하게 말씀드립니다. 상담 자체는 무료입니다.",
  ],
  [
    "다른 회사에서 가입한 보험도 봐주시나요?",
    "물론입니다. 어느 보험사에서 가입하셨든 전체를 한 번에 분석해 드립니다. 가입 증권만 있으면 됩니다.",
  ],
  [
    "멀리 살아도 상담이 가능한가요?",
    "네. 전화·카톡·인스타·화상으로 비대면 상담이 가능합니다. 필요하시면 직접 찾아뵙기도 합니다.",
  ],
  [
    "보험금 청구도 정말 도와주시나요?",
    "네, 그게 가장 중요한 일입니다. 어떤 서류가 필요한지, 어떻게 청구하는지 처음부터 끝까지 함께 챙겨 드립니다.",
  ],
];

export const recruitCards = [
  [
    "처음이어도 괜찮습니다",
    "경력이 없어도 됩니다. 기초 교육부터 현장 동행까지, 혼자 던져두지 않고 한 단계씩 함께 만들어 갑니다.",
  ],
  [
    "정직하게 오래 가는 일",
    "밀어붙이는 영업이 아니라, 고객을 평생 관리하는 방식. 그래서 한번 시작하면 오래, 멀리 갈 수 있습니다.",
  ],
  [
    "노력한 만큼의 소득",
    "나이·학력보다 태도와 꾸준함이 인정받는 일입니다. 한 만큼 정당하게 보상받는 구조를 함께 설계해 드립니다.",
  ],
];
